import { shareSNS } from './lib/_share.js';
import { Scroll } from './lib/_scroll.js';

export var common = {
	scrl: "",
	beforeW: 0,
	init: ()=>{
		common.start();
	},
	start: function(){
		let resizeFlag;
		let resizeTimer = null;
		let $body = document.getElementsByTagName('body')[0];
		
		common.resize();
		common.nav();
		common.scrl = new Scroll();
		
		/* window resize
		----------------------------- */
		var resizeCallback = function() {
			common.resize();
			resizeTimer = null;
		};
		window.addEventListener("resize", function(){
			if( !$body.classList.contains("resize") ){
				$body.classList.add("resize");
			}
			if(resizeTimer) {
				clearTimeout(resizeTimer);
			}
			resizeTimer = setTimeout(resizeCallback, 300);
		}, false);
	},
	nav: ()=>{
		let $btnMenu 	= document.querySelector("[data-menu]");
		if($btnMenu){
			//single handlers
			const eventListeners = [
				{ element: $btnMenu, type: "click", handler: common.toggleMenu}
			]
			eventListeners.forEach( ( el ) => {
				if(el.element){
					el.element.removeEventListener(el.type, el.handler, false);
					el.element.addEventListener(el.type, el.handler, false);
				}
			});
		}
		let $scrollNav = document.querySelectorAll("[data-scroll]");
		$scrollNav.forEach( ($n, index) => {
			$n.removeEventListener("click", common.scrollToPos, false);
			$n.addEventListener("click", common.scrollToPos, false);
		});
		
		let $accordions = document.querySelectorAll("[data-toggle-accordion]");
		$accordions.forEach( ($a, index) => {
			$a.removeEventListener("click", common.toggleAccordion, false);
			$a.addEventListener("click", common.toggleAccordion, false);
		});
		common.mailTo();
	},
	mailTo: function(){
		let $target = document.querySelector("[data-mail]");
		let address = "bWVldHVwMjAyNEBqLXdhdmUuY28uanA=";
		
		$target.innerText = decodeEmail(address);
		$target.removeEventListener("click", common.sendMail, false);
		$target.addEventListener("click", common.sendMail, false);
	},
	sendMail: function(){
		let address 		= "bWVldHVwMjAyNEBqLXdhdmUuY28uanA=";
		let decodedEmail 	= decodeEmail(address);
		const subject = encodeURIComponent("J-WAVE MEET UP 2024 についてお問い合わせ");
		window.location.href = `mailto:${decodedEmail}?subject=${subject}`;
	},
	toggleMenu: function(){
		let $html = document.documentElement;
		if( !$html.classList.contains("show_menu") ){
			$html.classList.add("show_menu");
		}else{
			$html.classList.remove("show_menu");
		}
	},
	resize: ()=>{
		var winW 	= window.innerWidth;
		var winH 	= window.innerHeight;
		let $body 	= document.getElementsByTagName('body')[0];
		
		addressbarH();
		
		common.getScrollBar();
		if(common.scrl){
			common.scrl.check();
			common.scrl.checkBlock();
		}
		common.setHeight();
		setTimeout(function(){
			if( $body.classList.contains("resize") ){
				$body.classList.remove("resize");
			}
			if(common.scrl){
				common.scrl.check();
				common.scrl.checkBlock();
			}
		},300);
		function addressbarH(){
			if(common.beforeW != winW){
				// 100vh、アドレスバーが出てる時に対応
				let vh = window.innerHeight * 0.01;
				document.documentElement.style.setProperty("--vh", `${vh}px`);
			}
		}
		common.beforeW = winW;
	},
	getScrollBar: function(){
		const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
		document.documentElement.style.setProperty('--scrollbar', `${scrollbarWidth}px`);
	},
	removeMultipleClass: function(dom, className){
		const target = document.querySelector(dom);
		const targetClassList = target.className;
		const myRegExp = new RegExp("/\b" + className + "\S+/", 'g');
		const myMatched = targetClassList.match(myRegExp) || [];
		for(let n = 0; n < myMatched.length; n++) {
		  target.classList.remove(myMatched[n]);
		}
	},
	scrollToPos: function(e){
		e.preventDefault();
		let headerH = document.querySelector("header#page_header").clientHeight;
		let id = this.getAttribute('href');
		//console.log(id);
		let posY = Math.floor( document.querySelector(id).getBoundingClientRect().top + window.pageYOffset );
		window.scrollTo({
			top: posY,
			behavior: "smooth"
		});
		common.toggleMenu();
	},
	toggleAccordion: function(e){
		e.preventDefault();
		let $this = this;
		let idx = this.getAttribute("data-toggle-accordion");
		let blocks = document.querySelectorAll(".accordion");
		let $target = blocks[idx];
		
		let $inner = $target.querySelector(".c-accordion_content_inner");
		let $content = $target.querySelector(".c-accordion_content");
		let h = 0;
		if( !$target.classList.contains("open") ){
			$target.classList.add("open");
			h = $inner.clientHeight;
		}else{
			$target.classList.remove("open");
			h = 0;
		}
		$content.style.height = h + "px";
		
		console.log(idx);
	},
	setHeight: function(){
		let blocks = document.querySelectorAll(".accordion");
		blocks.forEach( ($blk) => {
			if( $blk.classList.contains("open") ){
				let h = $blk.querySelector(".c-accordion_content_inner").clientHeight;
				$blk.querySelector(".c-accordion_content").style.height = h + "px";
			}
		});
	}
}
function decodeEmail(encodedEmail) {
	return atob(encodedEmail);
}